import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Communic8DownloadComponent } from './pages/communic8-download/communic8-download.component';
import { environment } from '@environments/environment';
import { HubioCommonPagesModule } from '@hubio/hubio-common-components';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './lib/paginator.intl';
import { FileDetailsComponent } from './pages/file-details/file-details.component';
import { DetailsPanelComponent } from './components/details-panel/details-panel.component';
import { BrokersTableComponent } from './components/brokers-table/brokers-table.component';
import { ErrorsTableComponent } from './components/errors-table/errors-table.component';
import { MatTreeModule } from '@angular/material/tree';
import { TransactionDetailsComponent } from './pages/transaction-details/transaction-details.component';
import { DataTreeComponent } from '../../core/components/data-tree/data-tree.component';
import { ModalComponent } from '../../core/components/modal/modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrokerMailComponent } from './pages/broker-mail/broker-mail.component';
import { TransactionsTableComponent } from './components/transactions-table/transactions-table.component';
import { AgentsComponent } from './pages/agents/agents.component';
import { AgentsTableComponent } from './components/agents-table/agents-table.component';
import { FileDropModalComponent } from './components/file-drop-modal/file-drop-modal.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    Communic8DownloadComponent,
    FilterBarComponent,
    FileDetailsComponent,
    DetailsPanelComponent,
    BrokersTableComponent,
    ErrorsTableComponent,
    TransactionDetailsComponent,
    DataTreeComponent,
    ModalComponent,
    BrokerMailComponent,
    TransactionsTableComponent,
    AgentsComponent,
    AgentsTableComponent,
    FileDropModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatTreeModule,
    MatDialogModule,
    MatChipsModule,
    MatTooltipModule,
    HubioCommonPagesModule.forRoot(environment),
  ],
  providers: [
    DatePipe,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }
  ]
})
export class Communic8DownloadModule { }
